import React, { useEffect } from 'react';
import classNames from 'classnames';
import useQueryParams from 'hooks/useQueryParams';
import AnalyticsDeals from './components/AnalyticsDeals';
import { SORTING_VALUES } from './components/AnalyticsDeals/components/data';
import AnalyticsNavigation from '../Analytics/components/AnalyticsNavigation';

import './Deals.styles.scss';

type DealsProps = {
  className?: string;
};

const Deals: React.FC<DealsProps> = (props) => {
  const { className } = props;

  const classes = classNames('deals', className);

  const {
    params: { sort },
    setQueryParam,
  } = useQueryParams();

  useEffect(() => {
    if (!sort) setQueryParam('sort', SORTING_VALUES.stage);
  }, [sort, setQueryParam]);

  if (!sort) return null;

  return (
    <div className={classes}>
      <AnalyticsNavigation />
      <AnalyticsDeals />
    </div>
  );
};

export default Deals;
